import { useState } from "react";
import PropTypes from "prop-types";

import { Modal } from "components/Modal";
import { trackEvent } from "utils/tracking";
import { FaqPanel } from "./FaqPanel";
import {
  RequestFeatureTypeForm,
  ContactUs,
} from "features/HelpCenter/v2/Components";
import {
  SettingsSupportIdeaIcon,
  SettingsSupportMailIcon,
  SettingsSupportFaqIcon,
  SettingsChevronRightIcon,
} from "assets/icons";
import { PanelContainer, SupportRow } from "./SupportPanel.styles";

const Row = ({ Icon, title, description, onClick }) => (
  <SupportRow type="button" onClick={onClick}>
    <span className="row-icon">
      <Icon />
    </span>
    <span className="row-text">
      <span className="row-title">{title}</span>
      <span className="row-description">{description}</span>
    </span>
    <SettingsChevronRightIcon className="row-chevron" aria-hidden="true" />
  </SupportRow>
);

Row.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export const SupportPanel = () => {
  const [showRequestFeature, setShowRequestFeature] = useState(false);
  const [showContactUs, setShowContactUs] = useState(false);
  const [showFaq, setShowFaq] = useState(false);

  if (showFaq) return <FaqPanel onBack={() => setShowFaq(false)} />;

  return (
    <PanelContainer>
      <h3 className="panel-heading">Support</h3>
      <p className="panel-subtitle">
        Get help or help shape what we build next.
      </p>

      <div className="support-list">
        <Row
          Icon={SettingsSupportIdeaIcon}
          title="Request a feature"
          description="Suggest an idea or improvement for Surmount."
          onClick={() => {
            trackEvent({ name: "submit_feedback", label: "Support" });
            setShowRequestFeature(true);
          }}
        />
        <Row
          Icon={SettingsSupportMailIcon}
          title="Contact us"
          description="Email our team about an issue and we'll respond promptly."
          onClick={() => {
            trackEvent({ name: "contact_support", label: "Support" });
            setShowContactUs(true);
          }}
        />
        <Row
          Icon={SettingsSupportFaqIcon}
          title="FAQs"
          description="Browse answers to common questions about Surmount."
          onClick={() => {
            trackEvent({ name: "view_faq", label: "Support" });
            setShowFaq(true);
          }}
        />
      </div>

      <Modal
        show={showRequestFeature}
        onHide={() => setShowRequestFeature(false)}
        size="lg"
        showClose={false}
      >
        <RequestFeatureTypeForm
          handleMenuClose={() => setShowRequestFeature(false)}
        />
      </Modal>

      <Modal
        show={showContactUs}
        onHide={() => setShowContactUs(false)}
        size="lg"
        showClose={false}
      >
        <ContactUs handleMenuClose={() => setShowContactUs(false)} />
      </Modal>
    </PanelContainer>
  );
};
